import { MsalAuthenticationResult } from '@azure/msal-react';

export function buildAuthErrorMessage({
  error,
}: MsalAuthenticationResult): string {
  return [
    'Authentication error. Please refresh and try again, or contact the administrator if the problem persists.',
    error && `(code: ${error.errorCode})`,
  ]
    .filter(Boolean)
    .join(' ');
}
